import { Gizmo } from "flowy-3-core";
import { Row } from "antd";
import { faro } from "../../assets/images";
// import PrivacyModal from "../../components/gizmos/visual/Button/PrivacyModal";

type LoginHeaderProps = {
  gizmo: Gizmo;
};

const LoginHeader = ({ gizmo }: LoginHeaderProps) => {
  return (
    <Row justify={"center"}>
      <img
        src={faro}
        style={{
          maxWidth: "45%",
        }}
        alt="-"
      />
    </Row>
  );
};

export default LoginHeader;
